import openFormStatus from '../form/form';

// указываем валюту
const currency = ' руб.';
const form = $('#paymentModal');

// соединяем цену и валюту
function addСurrencyToPrice(price, currency) {
  return price + currency;
}

// устанавливаем курсор перед вылютой
$.fn.setCursorPosition = function setCursorPosition(pos) {
  if ($(this).get(0).setSelectionRange) {
    $(this).get(0).setSelectionRange(pos, pos);

  } else if ($(this).get(0).createTextRange) {
    const range = $(this).get(0).createTextRange();

    range.collapse(true);
    range.moveEnd('character', pos);
    range.moveStart('character', pos);
    range.select();
  }
};

// добавляем валюту к текстовому полю
$.fn.addСurrencyToInput = function addСurrencyToInput(currency) {
  const price = parseInt($(this).val(), 10);
  if (price <= 0 || price == NaN || !price) {
    $(this).val('');
    return false;
  }

  const priceWithCurrency = addСurrencyToPrice(price, currency);

  $(this).val(priceWithCurrency);
  $(this).setCursorPosition(priceWithCurrency.length - currency.length);
}

function openFormPayment(currentForm) {
  // показываем модальное окно
  currentForm.show();
  currentForm.prev('#paymentModalOverlay').show();

  // Начинаем слушать клавишу Esc. При её нажатии, закарываем окно.
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      closeFormPayment(currentForm);
    }
  });
}

function closeFormPayment(currentForm) {
  currentForm.hide();
  currentForm.prev('#paymentModalOverlay').hide();
}

// при вводе текста в полю добавлять валюту
$("#userAmountOfPayment").on("input", function () {
  $(this).addСurrencyToInput(currency);
});

// при клике по текстовому полю добавлять валюту
$("#userAmountOfPayment").on("click", function () {
  $(this).addСurrencyToInput(currency);
});

// закрываем форму оплаты
$('.closeFormModal').click(function () {
  closeFormPayment(form);
});

// при клике по кнопке открытия...
$('.openFormModal').click( function () {
  // показываем форму оплаты
  openFormPayment(form);
});

// отправка формы
$('#userPaymentForm').submit(function (event) {
  event.preventDefault();

  const account = $('#userContractNumber').val();
  const amount = parseInt($('#userAmountOfPayment').val().replace(/\s+/g, ''), 10);

  if (account.length < 3) {
    openFormStatus('Ошибка!', 'Укажите верный номер договора.');
    return false;
  }

  if (amount < 1) {
    openFormStatus('Ошибка!', 'Укажите сумму.');
    return false;
  }

  $.post(
    'https://stats.mtrend.ru/payments/prepare/sberbank', {

      type: 'prePayment',
      account_id: account,
      sum: amount
    },
    function (response) {
      if (response.error) {
        openFormStatus('Ошибка!', response.message);
      } else {
        window.location.replace(response.formUrl);
      }
    }
  );
});



// WEBPACK FOOTER //
// ./app/blocks/form-modal/form-modal.js